import { Stack, Link, Text } from "@bookingcom/bui-react";
import React from "react";
export function FilterSection(props) {
    const { attributes, children, showReset, title, reset } = props;
    const { text: titleText, ...restTitle } = title;
    const { text: resetText, ...restReset } = reset;
    return (React.createElement(Stack, { attributes: attributes },
        React.createElement(Stack, { gap: 3, direction: "row" },
            React.createElement(Stack.Item, { grow: true },
                React.createElement(Text, { variant: "emphasized_1", ...restTitle }, titleText)),
            showReset ? React.createElement(Link, { ...restReset }, resetText) : undefined),
        children));
}
